import { render, staticRenderFns } from "./TaxcarddetailsNew.vue?vue&type=template&id=0846337f&scoped=true"
import script from "./TaxcarddetailsNew.vue?vue&type=script&lang=js"
export * from "./TaxcarddetailsNew.vue?vue&type=script&lang=js"
import style0 from "./TaxcarddetailsNew.vue?vue&type=style&index=0&id=0846337f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0846337f",
  null
  
)

export default component.exports